import { forwardRef, RefObject } from 'react'
import { useSelector } from 'react-redux'
import cn from 'clsx'

// Components
import IsStaff from 'components/base/isstaff'

// Types
import { State } from 'types'

import styles from './timestamp.css'

type TimestampInfo = {
  start: number | undefined
  end: number | undefined
  beat_start: number
  beat_count: number
}

type TimestampProps = {
  time: TimestampInfo | undefined
  totalTime: string
}

const Timestamp = ({ time, totalTime }: TimestampProps, ref: RefObject<HTMLDivElement>) => {
  const adminModeActive = useSelector<State, boolean>(state => state && state.auth.adminModeActive)
  if (time) {
    const { start, end, beat_start, beat_count } = time
    return (
      <div ref={ref} className={cn(styles.duration, styles.durationLoop)}>
        {adminModeActive && beat_count && (
          <IsStaff>
            <>{`${beat_start}:${beat_count} / `}</>
          </IsStaff>
        )}
        <span>
          {start && end && <span datatesting="waveform_loop_info">{`${start && start.toFixed(3)} - ${end && end.toFixed(3)}`}</span>}
          {` / ${totalTime}`}
        </span>
      </div>
    )
  }
  return (
    <div ref={ref} className={styles.duration}>
      <div>{totalTime}</div>
    </div>
  )
}

export default forwardRef(Timestamp)
